import random from 'toxilibs/random.js'
import Level from '../core/level.js'

const level = new Level({
    name: 'length',
    dependencies: [
        'levels/variables'
    ]
})


const randomLetter = random.unmistakableLetter
let randomLetters = random.unmistakableLetters

function addBads ({q, a}) {
    q.addBadChoices(a.length - 1, a.length + 1, a[0], a[1], 'digit')
}


level.addQuestion({
    generator: function (q) {
        let a = randomLetters(random.intBetween(2, 7))
        q.addCode({
            javascript: "let a = '" + a + "'\na.length",
            python: "a = '" + a + "'\nlen(a)"
        }, level.language)
        addBads({q, a})
    },
    timeoutTime: 10000,
    errorExpected: true,
    times: 2
})


level.addQuestion({
    generator: function (q) {
        let a = []
        const l = random.intBetween(3, 7)
        for (let i = 0; i < l; i++) {
            a.push(random.pick(random.intBetween(1, 9), randomLetter()))
        }
        let aForDisplay = q.codeArrayToDisplay(a)
        q.addCode({
            javascript: 'let a = ' + aForDisplay + '\na.length',
            python: 'a = ' + aForDisplay + '\nlen(a)'
        }, level.language)
        addBads({q, a})
    },
    errorExpected: true,
    timeoutTime: 12000,
    times: 2
})


export default level

